'use strict';

function objectHasKeys(obj) {
  return obj && Object.keys(obj).length > 0;
}
module.exports = objectHasKeys;